import { ComponentStyleConfig } from "@chakra-ui/react";

const Stat: ComponentStyleConfig = {
  baseStyle: {
    label: {
      textStyle: "body2",
      fontWeight: "semibold",
      marginBottom: 1,
      color: "grey.500",
    },
    number: {
      textStyle: "body",
      fontWeight: "semibold",
      whiteSpace: "nowrap",
    },
  },
  variants: {
    rightAlign: {
      label: {
        textAlign: "right",
      },
      number: {
        textAlign: "right",
      },
    },
  },
  sizes: {
    sm: {},
    lg: {
      number: { textStyle: "h2" },
    },
  },
  defaultProps: {
    size: "sm",
  },
};

export default Stat;
